<template>
  <div :class="['lr2-modal', {'hide': !show}]">
    <div class="lr-box">
      <div class="trv-head">Travelers</div>
      <div class="trv-subhead" v-if="trData.Product_available_date && trData.Product_available_date.length">
        <i class="fas fa-calendar fa-fw"></i>
        {{ dateLabel(trData.Product_available_date[0]) }}
      </div>
      <div class="d-flex justify-space-between trv-field">
        <div class="trv-form-label">
          <b>Adult</b>
          <div>Ages 18+</div>
        </div>
        <div class="d-flex align-start trv-form-value">
          <i :class="['fas fa-minus-circle', {maxed:adults === 1}]" @click="minus('adults')"></i>
          <span>{{ adults }}</span>
          <i :class="['fas fa-plus-circle', {maxed:adults + children >= (trData.MaxTravellerCount || 10)}]" @click="add('adults')"></i>
        </div>
      </div>
      <div class="d-flex justify-space-between trv-field" v-if="childAllowed">
        <div class="trv-form-label">
          <b>Child</b>
          <div>Ages 0 to 17</div>
        </div>
        <div class="d-flex align-start trv-form-value">
          <i :class="['fas fa-minus-circle', {maxed:children === 0}]" @click="minus('children')"></i>
          <span>{{ children }}</span>
          <i :class="['fas fa-plus-circle', {maxed:adults + children >= (trData.MaxTravellerCount || 10)}]" @click="add('children')"></i>
        </div>
      </div>

      <div class="d-flex justify-space-between action-box">
        <div class="op-btn btn-md btn-block btn-secodary" @click="show = false">Close</div>
        <div class="op-btn btn-md btn-block btn-danger" @click="getTripList">Continue</div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
export default {
  name: 'traveller-modal',
  props: ['trData'],
  data () {
    return {
      show: false,
      adults: 1,
      children: 0
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    travellers () { return this.booking.filters.travellers },
    sightSeeing () { return this.$store.state.sightSeeing },
    childAllowed () {
      if (this.trData && this.trData.Product_AgeBands) {
        let child = this.trData.Product_AgeBands.find(x => x.description === 'Child')
        if (child) return true
      }
      return false
    }
  },
  methods: {
    showModal () { this.show = true },
    dateLabel (x) {
      return x ? moment(x, 'YYYY-MM-DD').format('ddd, MMM DD YYYY') : ''
    },
    minus (x) {
      if ((x === 'adults' && this.adults === 1) || (x !== 'adults' && this[x] === 0)) return
      this[x]--
    },
    add (x) {
      let max = this.trData.MaxTravellerCount || 10
      if ((this.adults + this.children) >= max) return
      this[x]++
    },
    fieldDesc (field) {
      if (!this.trData || (this.trData && !this.trData.Product_AgeBands)) return ''
      let x = this.trData.Product_AgeBands.find(x => x.description === field)
      if (x) return `Age ${x.ageFrom} - ${x.ageTo}`
      return ''
    },
    getTripList () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})
      self.show = false

      let ageBands = [{bandId: 'ADT', count: self.adults}]
      if (self.children) ageBands.push({bandId: 'CHD', count: self.children})

      let total = this.adults + this.children
      this.$store.commit('booking/setTravellersData', {
        total: total,
        adult: this.adults,
        children: this.children,
        infants: 0
      })

      self.$sdk.post2(`${CONFIG.d2dAPI}/sightseeing/provider1/trip-list`, {
        ProductCode: self.trData.ProductCode,
        ResultToken: self.trData.ResultToken,
        BookingDate: moment(self.sightSeeing.date.start, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        ageBands: ageBands
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (!r.Status) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.Message
          })
          return
        }
        self.$store.commit('sightSeeing/setTripsData', {
          details: r.TripList.ProductDetails,
          list: r.TripList.Trip_list,
          show: true
        })
        self.$router.push('/sight-seeing/trips')
      })
    }
  },
  mounted () {
    this.adults = this.travellers.adult
    this.children = this.travellers.children
  }
}
</script>

<style lang="scss" scoped>
.lr-box {
  padding: 20px;
  min-width: 300px;
  max-width: 400px;
}
.trv-head{
  font-size: 18px;
  font-weight:600;
}
.trv-subhead{
  color: #777;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
  padding-bottom: 5px;
}
.trv-field{
  margin-bottom: 10px;
}
.trv-form-label{
  text-align: left;
  b{
    font-size: 16px;
  }
  div{
    font-size: 13px;
    color: #777;
  }
}
.trv-form-value{
  gap: 10px;

  i{
    font-size: 25px;
    color: #5E6E7F;
    cursor: pointer;

    &.maxed{
      color:#BEBEBE;
      cursor: default;
    }
  }
  span{
    display: inline-block;
    text-align: center;
    width: 40px;
    font-size: 21px;
    font-weight: 600;
  }
}

.action-box{
  gap: 20px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// traveller-modal.vue?7b7da74c